import { PaginationResult } from "../../../../Shared/Model/PaginationResult";
import { Customer } from "../../Domain/Model/Customer";
import { CustomerRepository } from "../../Domain/Repository/CustomerRepository";
import CustomerDataSource from "../DataSource/CustomerDataSource";

export class CustomerRepositoryImpl implements CustomerRepository {
  dataSource: CustomerDataSource;

  constructor(_datasource: CustomerDataSource) {
    this.dataSource = _datasource;
  }
  // updateColor(data: Color): Promise<boolean> {
  //   return this.dataSource.updateColor(data);
  // }
  getCustomers(page: number, pageSize: number, search: string): Promise<PaginationResult<Customer>> {
        return this.dataSource.getCustomers(page, pageSize, search);
    }

  // createColor(data: Color): Promise<Color[]> {
  //     return this.dataSource.createColor(data);
  // }

//   removeColor(id: string): Promise<boolean> {
//     return this.dataSource.removeColor(id);
// }
    
}